import React, { ReactNode, useRef, useState } from 'react';
import styled from 'styled-components';
import { ClipDataBuilder, ClipboardService } from '../../platform/Clipboard';
import { Tip } from '../../ui/Tip';
import { useResolve } from '../Container';

const Wrapper = styled.div`
    display: inline-block;
    cursor: pointer;
`;

export const CopyToClipboard = React.memo(({ children, value }: { children: ReactNode, value: string }) => {

    const clipboard = useResolve(ClipboardService);
    const [copied, setCopied] = useState(false);
    const ref = useRef<HTMLDivElement>();

    const onCopy = () => {
        const data = new ClipDataBuilder();
        data.setText(value);
        clipboard.write(data.build());
        setCopied(true);
    };

    return <Tip rest={1} text={copied ? 'Copied!' : 'Click to copy'} position="top">
        <Wrapper ref={ref} onMouseEnter={() => setCopied(false)} onClick={onCopy}>
            {children}
        </Wrapper>
    </Tip>;
});
